export const getCurrentLink = (links, location) => {
  const currentLink = links.find(link => link.path === location.pathname.split("/")[3]);
  return currentLink ? currentLink : {};
};
